export const LANGUAGE_OPTIONS = [
  { code: 'ru', name: 'Русский', country: 'ru' },
  { code: 'en', name: 'English', country: 'gb' },
  { code: 'uk', name: 'Українська', country: 'ua' },
  { code: 'pt', name: 'Português', country: 'pt' },
  { code: 'es', name: 'Español', country: 'es' },
  { code: 'tr', name: 'Türkçe', country: 'tr' },
  { code: 'kk', name: 'Қазақша', country: 'kz' },
  { code: 'uz', name: "O'zbek", country: 'uz' },
  { code: 'id', name: 'Indonesia', country: 'id' },
  { code: 'tg', name: 'Тоҷикӣ', country: 'tj' },
  { code: 'ky', name: 'Кыргызча', country: 'kg' },
  { code: 'ar', name: 'العربية', country: 'sa' },
  { code: 'fa', name: 'فارسی', country: 'ir' }
]

export const SUPPORTED_LANGUAGES = LANGUAGE_OPTIONS.map(({ code }) => code)
export const RTL_LANGUAGES = ['ar', 'fa']

export const normalizeLanguageCode = (languageCode) => {
  if (typeof languageCode !== 'string' || !languageCode.trim()) return null

  const normalizedLanguageCode = languageCode.toLowerCase().replace('_', '-')
  if (SUPPORTED_LANGUAGES.includes(normalizedLanguageCode)) return normalizedLanguageCode

  const baseLanguageCode = normalizedLanguageCode.split('-')[0]
  return SUPPORTED_LANGUAGES.includes(baseLanguageCode) ? baseLanguageCode : null
}
